import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { getCase } from './cases';
import CaseStudy from './CaseStudy';

/* Maps /product/:slug → the right case study, or bounces home if unknown. */
function CaseStudyRoute() {
  const { slug } = useParams();
  if (!getCase(slug)) return <Navigate to="/product" replace />;
  return <CaseStudy slug={slug} />;
}

export default CaseStudyRoute;
